// extracted by mini-css-extract-plugin
export var label = "FooterItemV2-module--label--7c79a";